module.exports = __webpack_public_path__ + "static/media/400145_02.d4f5b22d.png";